import { BulkActionButton } from '@user/components/xGrid/atoms/BulkActions/BulkActionButton'
import * as React from 'react'

type Props = { hasPermission: boolean }

export function BulkAddActivityButton(props: Props) {
  const { hasPermission } = props

  return (
    <BulkActionButton
      type="createActivity"
      helperText="Mass activity creation. This action cannot be undone or recovered."
      hasPermission={hasPermission}
      errorString="You do not have permissions to perform bulk action creation."
    >
      Add Activity
    </BulkActionButton>
  )
}
